import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorIncapacidadesComponent {
  idProyecto
  idColaborador
  agregando = false

  constructor (ColaboradorIncapacidades) {
    this.ColaboradorIncapacidades = ColaboradorIncapacidades
  }

  $onInit () {
    this.promise = this.ColaboradorIncapacidades.get(this.idProyecto, this.idColaborador)
      .then(({data}) => (this.data = data))
  }

  actualizar (data) {
    this.data = data
  }

  agregar (data) {
    this.agregando = false

    if (data) {
      this.data = [...this.data, data]
    }
  }
}

module.component('colaboradorIncapacidades', {
  controller: ColaboradorIncapacidadesComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/incapacidades/component.js